import UserEndpoints from "../../structure/userEndpoints";
import { request } from "../mainRequest";
import {
  Order,
  TableAllReq,
  TableAllRes,
  TableOverallRes,
  TableReq,
} from "./tableInterfaces";

export function getTable(data: TableReq): Promise<Array<Order>> {
  return request(UserEndpoints.GetTable, data);
}

export function getAllTable(data: TableAllReq): Promise<Object> {
  return request(UserEndpoints.GetAllTable, data);
}

export function getAllAccTable(data: {
  period?: string;
}): Promise<Array<TableAllRes>> {
  return request(UserEndpoints.GetAllAccsTable, data);
}
export function getOverallAccTable(data: {
  period?: string;
}): Promise<Array<TableOverallRes>> {
  return request(UserEndpoints.GetAllAccsTable, data);
}

export function getOverall(): Promise<Order> {
  return request(UserEndpoints.GetOverall);
}
